import React from 'react';
import styled from 'styled-components';

import useTranslation from 'src/hooks/use-translation';
import { DutchiePayHeader, DutchiePayTextBody } from 'src/payments/components';
import PaymentUnsuccessfulIcon from 'src/assets/unsuccessful-icon';
import { PBB_NAME } from 'src/payments/constants';

import { OrderHeaderCard } from '../base/order-header';

export function PaymentUnsuccessfulHeader(): JSX.Element {
  const { t } = useTranslation();

  return (
    <OrderHeaderCard
      icon={<PaymentUnsuccessfulIcon />}
      body={
        <>
          <DutchiePayHeader>
            {t('dutchie.in-store.order-header.payment-unsuccessful', 'Payment was Unsuccessful')}
          </DutchiePayHeader>

          <DutchiePayTextBodyWithoutMargin>
            {t('dutchie.in-store.order-header.unable-to-process', `${PBB_NAME} was not able to process this payment.`)}
          </DutchiePayTextBodyWithoutMargin>
        </>
      }
      footer={
        <DutchiePayTextBodyWithoutMargin>
          {t(
            'dutchie.in-store.order-header.different-method',
            'Please use a different method of payment or ask your retailer to try again.'
          )}
        </DutchiePayTextBodyWithoutMargin>
      }
    />
  );
}

// FIXME: Remove margin on DutchiePayTextBody
const DutchiePayTextBodyWithoutMargin = styled(DutchiePayTextBody)`
  margin: 0;
`;
